/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\invitation.genclient.json
 */

"use strict";

/**
 * Invitation Data
 */
export interface InvitationData {
    /**
     * Invitation Attributes
     */
    attributes: { [key: string] : string; };
    /**
     * Type of Invitation
     */
    invitationType: InvitationType;
    /**
     * User Ids of invitation recipients
     */
    invitees: Invitee[];
    /**
     * Id of the Sender
     */
    senderId: string;
}

/**
 * Enum value indicating type of invitation
 */
export enum InvitationType {
    /**
     * Send invitation to organization
     */
    AccountInvite = 1,
    /**
     * Send invitation to Directory
     */
    DirectoryInvite = 2
}

/**
 * Invitation Data
 */
export interface Invitee {
    message: string;
    status: InviteeStatus;
    /**
     * Type of Invitation
     */
    userId: string;
}

export enum InviteeStatus {
    None = 0,
    Success = 1,
    Failed = -1
}

/**
 * User invitation response
 */
export interface SendInvitationsResponse {
    invitationType: InvitationType;
    /**
     * Batch users' invitation response
     */
    invitees: Invitee[];
}

export var TypeInfo = {
    InvitationData: <any>{
    },
    InvitationType: {
        enumValues: {
            "accountInvite": 1,
            "directoryInvite": 2
        }
    },
    Invitee: <any>{
    },
    InviteeStatus: {
        enumValues: {
            "none": 0,
            "success": 1,
            "failed": -1
        }
    },
    SendInvitationsResponse: <any>{
    },
};

TypeInfo.InvitationData.fields = {
    invitationType: {
        enumType: TypeInfo.InvitationType
    },
    invitees: {
        isArray: true,
        typeInfo: TypeInfo.Invitee
    }
};

TypeInfo.Invitee.fields = {
    status: {
        enumType: TypeInfo.InviteeStatus
    }
};

TypeInfo.SendInvitationsResponse.fields = {
    invitationType: {
        enumType: TypeInfo.InvitationType
    },
    invitees: {
        isArray: true,
        typeInfo: TypeInfo.Invitee
    }
};
